/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const AddPanelSearch64Icon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 64, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="AddPanelSearch64Icon"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            d="M35.6316 34.6316L42.5 41.5M37.8846 29.1923C37.8846 33.4407 34.4407 36.8846 30.1923 36.8846C25.944 36.8846 22.5 33.4407 22.5 29.1923C22.5 24.944 25.944 21.5 30.1923 21.5C34.4407 21.5 37.8846 24.944 37.8846 29.1923Z"
            stroke="currentColor"
          />
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

AddPanelSearch64Icon.tags = ['search', 'magnify', 'find', 'zoom', 'explore'];

AddPanelSearch64Icon.category = '64x64 (Add panel)';

AddPanelSearch64Icon.iconSize = 64;
